module.exports = __webpack_public_path__ + "static/media/resetpassword.eb924d49.svg";